// extracted by mini-css-extract-plugin
export var arrow = "VideoSection-module--arrow--86f70";
export var back = "VideoSection-module--back--fcf50";
export var clickable = "VideoSection-module--clickable--a0c37";
export var details = "VideoSection-module--details--0def7";
export var header = "VideoSection-module--header--66251";
export var hide = "VideoSection-module--hide--386d1";
export var overviewTimeline = "VideoSection-module--overviewTimeline--09709";
export var progress = "VideoSection-module--progress--c23ed";
export var root = "VideoSection-module--root--ce21e";
export var selected = "VideoSection-module--selected--913d5";
export var share = "VideoSection-module--share--08589";
export var spacer = "VideoSection-module--spacer--47c88";
export var tab = "VideoSection-module--tab--86a70";
export var tabs = "VideoSection-module--tabs--c2caf";
export var tags = "VideoSection-module--tags--90cee";
export var timeline = "VideoSection-module--timeline--1a15a";
export var timelineContainer = "VideoSection-module--timelineContainer--9bf1c";
export var timelinesContent = "VideoSection-module--timelinesContent--c9868";
export var timelinesToggle = "VideoSection-module--timelinesToggle--eb6e9";
export var timestampsTimeline = "VideoSection-module--timestampsTimeline--fec31";
export var title = "VideoSection-module--title--29e5d";
export var unCollapsed = "VideoSection-module--unCollapsed--645dc";
export var video = "VideoSection-module--video--41046";
export var videoContainer = "VideoSection-module--videoContainer--c4ee6";
export var videoPlayer = "VideoSection-module--videoPlayer--6f039";
export var videoWrapper = "VideoSection-module--videoWrapper--e83dc";
export var youtube = "VideoSection-module--youtube--5df1c";